module.exports = __webpack_public_path__ + "img/team-internship.1b45fef4.svg";